import React, { Component } from 'react';
import Navbar from '../components/Layouts/Navbar';
import SubscribeStyleOne from '../components/Common/SubscribeStyleOne';
import Footer from '../components/Layouts/Footer';
import PageSeo from '../components/Common/PageSeo';
import BusinessAnalyticsDataAsResource from '../components/BusinessAnalytics/BusinessAnalyticsDataAsResource';
import BusinessAnalyticsFAQ from '../components/BusinessAnalytics/BusinessAnalyticsFAQ';
import BusinessAnalyticsWeitereDienstleistungen from '../components/BusinessAnalytics/BusinessAnalyticsWeitereDienstleistungen';
import BusinessAnalyticsInfoAndCTA from '../components/BusinessAnalytics/BusinessAnalyticsInfoAndCTA';
import BusinessAnalyticsTools from '../components/BusinessAnalytics/BusinessAnalyticsTools';
import BusinessAnalyticsHeader from '../components/BusinessAnalytics/BusinessAnalyticsHeader';
import { useTranslations } from '../locales/useTranslations';
import { useRouter } from 'next/router';

const BusinessAnalytics = () => {
    const { t } = useTranslations();
    const { locale } = useRouter();
    const baseUrl = locale === 'en' ? 'https://simplify-data.com' : 'https://simplify-data.de';

    return (
        <>
            <PageSeo
                title={t('businessAnalytics_page_title')}
                description={t('businessAnalytics_page_description')}
                canonical={`${baseUrl}/business-analytics/`}
                openGraph={{
                    url: `${baseUrl}/business-analytics/`,
                    title: t('businessAnalytics_page_title'),
                    description: t('businessAnalytics_page_description'),
                    images: [
                        {
                            url: `${baseUrl}/images/simplify-data.png`,
                            width: 1200,
                            height: 1200,
                            alt: t('businessAnalytics_page_ogImageAlt1'),
                            type: 'image/jpeg',
                        },
                    ],
                    siteName: t('businessAnalytics_page_title'),
                    type: 'website'
                }}
                twitter={{
                    handle: '@simplify_data',
                    site: '@simplify_data',
                    cardType: 'summary_large_image',
                }}
                additionalMetaTags={[
                    {
                        name: 'robots',
                        content: 'index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1',
                    },
                    {
                        name: 'keywords',
                        content: t('businessAnalytics_page_keywords')
                    },
                    {
                        name: 'author',
                        content: 'Simplify Data'
                    },
                    {
                        name: 'geo.region',
                        content: 'DE-SH'
                    },
                    {
                        name: 'geo.placename',
                        content: 'Kiel'
                    },
                    {
                        property: 'article:modified_time',
                        content: new Date().toISOString()
                    },
                    {
                        name: 'format-detection',
                        content: 'telephone=no'
                    }
                ]}
                additionalLinkTags={[
                    {
                        rel: 'icon',
                        href: `${baseUrl}/images/favicon.png`,
                        type: 'image/png'
                    },
                    {
                        rel: 'alternate',
                        hrefLang: 'de',
                        href: `https://simplify-data.de/business-analytics/`
                    },
                    {
                        rel: 'alternate',
                        hrefLang: 'en',
                        href: `https://simplify-data.com/business-analytics/`
                    }
                ]}
            />

            <Navbar />
            <BusinessAnalyticsHeader />
            <BusinessAnalyticsDataAsResource />
            <BusinessAnalyticsTools />
            <BusinessAnalyticsInfoAndCTA />
            <BusinessAnalyticsFAQ />
            <BusinessAnalyticsWeitereDienstleistungen />
            { /*                 
        <ServiceRightImageBusinessAnalytics/> 
        */}
            <SubscribeStyleOne />
            <Footer />
        </>
    );
}

export default BusinessAnalytics;